<div class="layout-topbar">
  <div class="left-block item-block">
    <a class="icon" (click)="toggleSideMenu()">
      <i class="fas fa-bars"></i>
    </a>
    <img
      class="logo item hidden sm:inline-block lg:inline-block md:inline-block"
      src="assets/images/logo.png"
    />
    <h1 *ngIf="isDev" class="environmentName">(DEV)</h1>
    <h1 *ngIf="isUat" class="environmentName">(UAT)</h1>
  </div>
  <div class="right-block item-block">
    <div class="item">
      <ng-container *ngTemplateOutlet="menuSearchPanel"></ng-container>
    </div>
    <div
      class="item hidden lg:inline-block md:inline-block"
      (click)="userInfoPanel.toggle($event)"
    >
      <a class="icon"
        ><span class="user-name">{{ userName }}</span></a
      >
    </div>
    <div
      class="item hidden lg:inline-block md:inline-block"
      style="margin-right: 10px"
      (click)="userMenu.toggle($event)"
    >
      <span id="UserMenu" class="fa-stack fa-1x">
        <a class="icon"><i class="fas fa-user-cog"></i></a>
      </span>
    </div>
    <div
      class="item hidden lg:inline-block md:inline-block"
      style="margin-right: 10px"
      (click)="bellNotifyPanel.toggle($event)"
    >
      <span id="bellNotification" class="fa-stack fa-1x">
        <a class="icon"><i class="fas fa-bell"></i></a>
      </span>
    </div>
    <div class="item">
      <laas-facility-dropdown
        [dropdownStyle]="{ 'min-width': '15vw' }"
        [isIcon]="true"
        [showClear]="false"
        [showFilter]="false"
        [defaultSelectFirst]="true"
        (onOptionDataChange)="optionsDataOnChange($event, 'facility')"
      >
      </laas-facility-dropdown>
    </div>
    <div class="item">
      <ng-container *ngTemplateOutlet="languageDropdown"></ng-container>
    </div>

    <div class="item">
      <a class="icon" (click)="logout()"><i class="fas fa-sign-out-alt"></i></a>
    </div>
  </div>
</div>

<p-overlayPanel #userInfoPanel>
  <div>
    <b>User Name: </b><i>{{ userName }}</i>
  </div>
  <div>
    <b>Email : </b><i>{{ email }}</i>
  </div>
</p-overlayPanel>

<p-overlayPanel #userMenu id="userMenu">
  <p-panelMenu [multiple]="false" [model]="topMenus"></p-panelMenu>
</p-overlayPanel>

<p-overlayPanel #bellNotifyPanel [style]="{width: '420px'}" styleClass="notify-overlay" (onShow)="updateBellNotidy()">
  <ng-template pTemplate>
    <div class="notify-header">
      <span class="notify-header-title" (click)="goToBellNotificationsPage()">
        {{ 'Common.Button.ShowAll' | translate }}
      </span>
      <div class="notify-tab-group">
        <span
          class="notify-tab"
          [class.active]="showAllBellNotify"
          (click)="changeBellNotify('all')">
          {{ 'Common.Button.All' | translate }}
        </span>
        <span
          class="notify-tab"
          [class.active]="!showAllBellNotify"
          (click)="changeBellNotify('unread')">
          {{ 'Common.Button.Unread' | translate }}
        </span>
      </div>
    </div>
    <div class="notify-list-container">
      <p-dataView [value]="bellNotifications" sortField="notifyDt" layout="list" [loading]="isLoading">
        <ng-template let-bellNotifications pTemplate="list">
          <div *ngFor="let notification of bellNotifications;">
            <div class="notification-list-item"
                 [class.unread]="notification.isRead !== 1"
                 (click)="goToBellNotificationsContentPage(notification)">
              <div class="notify-dot-wrapper">
                <span class="dot" *ngIf="notification.isRead !== 1"></span>
              </div>
              <div class="notification-list-detail">
                <div class="notification-title">
                  {{notification.title}}
                </div>
                <div class="notification-time">
                  <i class="pi pi-clock"></i>
                  {{ notification.notifyDt | date:'yyyy-MM-dd HH:mm' }}
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </p-dataView>
    </div>
  </ng-template>
</p-overlayPanel>

<!--Language options-->
<ng-template #languageDropdown>
  <p-dropdown
    [(ngModel)]="languageData"
    [options]="languageOptions"
    optionLabel="label"
    [dataKey]="'value'"
    (onChange)="languageChange($event)"
    class="languageOptions"
  >
    <!-- 顯示已選項目的 abbreviation -->
    <ng-template let-lang pTemplate="selectedItem">
      <span>{{ lang?.abbreviation }}</span>
    </ng-template>

    <!-- 下拉選單項目：預設顯示 label -->
    <ng-template let-lang pTemplate="item">
      <span>{{ lang?.label }}</span>
    </ng-template>

    <!-- 刪掉下拉 Icon -->
    <ng-template pTemplate="dropdownicon"></ng-template>
  </p-dropdown>
</ng-template>

<!--Search page-->
<ng-template #menuSearchPanel>
  <div class="menu-search-wrapper" #searchWrapper>
    <div class="relative w-full">
      <div class="flex">
        <input
          type="text"
          pInputText
          [(ngModel)]="searchKeyword"
          (input)="menuSearchInputChange()"
          (keydown)="menuSearchKeydown($event)"
          (focus)="menuSearchFocus()"
          class="w-full"
          placeholder="{{ 'Menu.Message.SearchPlaceHolder' | translate }}"
        />
      </div>
      <div
        *ngIf="showPanel && filteredMenus.length > 0"
        class="menu-dropdown absolute z-5 w-full bg-white border shadow-md max-h-60 overflow-auto mt-1 rounded-md"
      >
        <div
          *ngFor="let menu of filteredMenus; let i = index"
          [class.bg-blue-50]="i === highlightedIndex"
          class="p-2 cursor-pointer rounded-sm duration-150 menu-option"
          (mouseenter)="highlightedIndex = i"
          (click)="selectMenu(menu)"
        >
          <div class="flex items-center">
            <i [class]="menu.icon" class="mr-2 text-gray-600"></i>
            <div>
              <div class="font-medium text-gray-800">{{ menu.label }}</div>
              <small class="text-gray-500">{{ menu.nodeNameEN }}</small>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
